/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register('service-worker.js', {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      // Send message to SW to skip the waiting and activate the new SW
      if (registration && registration.waiting) {
        /*const confirmUpdate = confirm("An update is available, click ok to install.");
        if (confirmUpdate == true) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        } else {
          document.dispatchEvent(
            new CustomEvent('swUpdated', { detail: registration })
          )
        }*/
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        location.reload();
      }
      /*document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )*/
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
